/**
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

/** en-dash — must match translated copy used in document titles */
export const pageTitleSeparator = '–'

/** Brand-suffix translation key appended to every routed page title. */
export const SIGNUP_BRAND_META_TITLE_KEY = 'signup.generic.metaTitle.app'

/**
 * Fallback values used when a translation key is missing from the catalogue.
 * Keeps the document title meaningful when the translation pipeline has not
 * yet shipped a new key.
 */
export const META_TITLE_FALLBACKS: Record<string, string> = {
  [SIGNUP_BRAND_META_TITLE_KEY]: 'Porsche ID',
}

/**
 * Builds the standard `[<page>, <brand>]` meta-title key tuple consumed by
 * `MetaFieldsService.updateTitle(...)`. Use as the value of `data.metaTitleKeys`
 * on every routed page.
 */
export const signupPageMetaTitleKeys = (pageKey: string): string[] => [pageKey, SIGNUP_BRAND_META_TITLE_KEY]

export const SIGNUP_REGISTER_META_TITLE_KEYS = signupPageMetaTitleKeys('signup.register.prospect.metaTitle')
export const SIGNUP_CONFIRMATION_META_TITLE_KEYS = signupPageMetaTitleKeys('signup.confirmation.metaTitle')
export const SIGNUP_BLOCKED_META_TITLE_KEYS = signupPageMetaTitleKeys('signup.blocked.metaTitle')
export const SIGNUP_MAINTENANCE_META_TITLE_KEYS = signupPageMetaTitleKeys('signup.maintenance.metaTitle')
export const SIGNUP_ERROR_META_TITLE_KEYS = signupPageMetaTitleKeys('signup.errorPage.metaTitle')
export const SIGNUP_SUCCESS_META_TITLE_KEYS = signupPageMetaTitleKeys('signup.successPage.metaTitle')
